export default "__VITE_ASSET__DR$zsZfL__"